import { render, staticRenderFns } from "./ServerDetails.vue?vue&type=template&id=141a7c56&scoped=true"
import script from "./ServerDetails.vue?vue&type=script&lang=js"
export * from "./ServerDetails.vue?vue&type=script&lang=js"
import style0 from "./ServerDetails.vue?vue&type=style&index=0&id=141a7c56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141a7c56",
  null
  
)

export default component.exports